import React, { useState, useEffect } from 'react'

import JsonDiffReact from 'jsondiffpatch-for-react';
import { Box } from "grommet"

// https://stackoverflow.com/questions/46982698/how-do-i-convert-all-property-values-in-an-object-to-type-string/46982882
// use function to convert all non object values a string
// to deal like market_id = 2 to market_id = "2" to match zkdata from Hasura
function toString(o) {
    Object.keys(o).forEach(k => {
      if (typeof o[k] === 'object') {
        return toString(o[k]);
      }
      o[k] = '' + o[k];
    });
    
    return o;
  }

const DiffDisplay = ({ oldValue, newValue, mTimeHasura }) => {
    const [oldValueCleaned, setoldValueCleaned] = useState("")
    const [newValueCleaned, setnewValueCleaned] = useState("")

    useEffect(() => {
        // For hasura data we need to delete status_message and add mtime
        let temp = oldValue
        delete temp.status_message
        temp.mtime = mTimeHasura
        setoldValueCleaned(toString(temp))
    }, [oldValue, mTimeHasura])

    useEffect(() => {
        let temp = newValue
        setnewValueCleaned(toString(temp))
    }, [newValue])

    return (
        <Box gap="small">
            {newValueCleaned && oldValueCleaned &&
                <Box fill background="white" overflow={{ horizontal: 'hidden', vertical: 'auto' }} pad="small">
                    <JsonDiffReact
                        left={oldValueCleaned}
                        right={newValueCleaned}
                        tips="✅ LSD Data and Watcher Data Are Identical"
                    />
                </Box>
            }
        </Box>
    )
}

export default DiffDisplay
